var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / System / ic_arrow_left_48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.13709224,2.84628998 C6.94720004,2.645904 6.9556146,2.32943348 7.15588669,2.13943329 C7.35615879,1.94943311 7.67244945,1.95785246 7.86234166,2.15823843 L16.8629089,11.6561926 C17.0457001,11.8490852 17.0456966,12.1513641 16.862901,12.3442525 L7.86233376,21.8417699 C7.67243696,22.0421515 7.35614611,22.0505636 7.15587837,21.8605588 C6.95561063,21.670554 6.94720333,21.3540833 7.13710014,21.1537017 L15.8116421,12.0002104 L7.13709224,2.84628998 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-System-/-ic_arrow_left",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_arrow_left",
    fill: "#000000",
    fillRule: "nonzero",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) ",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeft);
export default __webpack_public_path__ + "static/media/ic_arrow_left.d1061fbea4467f31e4c200bf4a0ce56b.svg";
export { ForwardRef as ReactComponent };